export default {
  root: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column'
  }
};
